import type { TQueryConstructor } from '@hozana/api/types'
import { normalize } from '@hozana/redux/normalize'
import { cookie } from '@hozana/storage/cookies'

import entities, { TRawUser } from 'config/entities'
import { COOKIES, COOKIES_CONFIG } from 'general/managers/cookies/constants'

import { saveTokenCookie } from 'modules/auth/functions'

import { GENDER, getMeQueryKey } from './constants'
import type { TLocation, TMe } from './types'

export const getMeQuery: TQueryConstructor<void, number> = () => ({
  queryKey: getMeQueryKey,
  url: '/me',
  normalize: (data: TMe) => normalize(data, entities.user),
  onSuccess: () => {
    cookie.save(COOKIES.hasAlreadyLogged, true, COOKIES_CONFIG.ONE_YEAR)
  },
})

/*
 * MUTATIONS
 */

export const updateUserSessionAppTypeMutation: TQueryConstructor<{ appType: string }, void> = ({ appType }) => ({
  queryKey: 'setCurrentAppType',
  url: `/me`,
  method: 'PATCH',
  params: { appType },
})

export type TEditAccountSettingsMutationPayload = {
  email?: string
  notificationEmail?: string
  oldPassword?: string
  password?: string
  lang?: string
  avatarId?: number
  customAvatarFileId?: number
  name?: string
  title?: string
  location?: TLocation
  birthdate?: string
  gender?: GENDER
}

export const editAccountSettingsMutation: TQueryConstructor<TEditAccountSettingsMutationPayload, number> = ({
  email,
  notificationEmail,
  oldPassword,
  password,
  lang,
  avatarId,
  customAvatarFileId,
  name,
  title,
  location,
  birthdate,
  gender,
}) => ({
  queryKey: 'editAccountSettings',
  url: '/me/settings',
  method: 'PATCH',
  params: {
    email,
    notificationEmail,
    oldPassword,
    password,
    lang,
    avatarId,
    customAvatarFileId,
    name,
    title,
    location,
    // If birthdate is undefined, it won't be changed. If null or '', it will be deleted
    birthdate: birthdate === undefined ? undefined : birthdate ? birthdate.split('/').reverse().join('-') : null,
    gender,
  },
  normalize: (data: TRawUser) => {
    if (email) {
      // A new token is provided if user change his email
      saveTokenCookie(data.token)
    }
    return normalize(data, entities.user)
  },
})
